import Actions from '../Collection/actions'

const actions = Actions.get('COUPON_CAMPAIGNS_');

export default actions;
